module.exports = __webpack_public_path__ + "media/static/icons/icon-beach--red-345a4535305f4cd7816875878e115484.svg";